import { useTheme } from "@hooks";
import { constants } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      userSelect: "none",
      backgroundColor: theme.goal.progress.background,
      padding: constants.divPadding,
      borderRadius: constants.radius.view,
    },
    left: {
      flexGrow: 1,
    },
    right: {
      fontWeight: "bold",
    },
  };

  return styles;
};
